'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/tooltip-template.html'));
var BidPriceChartController = function BidPriceChartController($scope, dataProviderService, $timeout) {
  var NOT_AVAIL = 'N/A';
  $scope.updateChart = function () {
    dataProviderService.getData($scope.entityData.serviceId, $scope.entityData.associatedLegCabins, $scope.selectedLegCabin).then($scope.timeoutRender);
  };
  $scope.timeoutRender = function (data) {
    $timeout(function () {
      $scope.renderChart(data);
    }, 0);
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d) {
      return d;
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return d;
    },
    tooltipFormatter: function tooltipFormatter(d) {
      return tooltipTemplate({
        seatAvailIndex: _.get(d, '0.seatAvailIndex', NOT_AVAIL),
        bidPrice: _.get(d, '0.bidPrice', NOT_AVAIL)
      });
    }
  };
};
BidPriceChartController.$inject = ['$scope', 'BidPriceChartDataProviderService', '$timeout'];
module.exports = BidPriceChartController;